import React from 'react';
import { CONFIG } from 'config/config';
import * as S from './styles';



const Text2StepsProgressBar = ({ step }) => {
	return (
		<>
			<S.ProgressTextWrapper>
				<S.ProgressTexts>
					{CONFIG.components.progressBar.textSteps.map((item, index, list) => (
						<S.ProgressText key={`pbt-${index}`}>
							<S.ProgressBarLabel
								showLabel={false}
								activeStep={(step === 1 && index === 0) || (step > 1 && index > 0)}
							>
								{item}
							</S.ProgressBarLabel>
						</S.ProgressText>
					))}
				</S.ProgressTexts>
			</S.ProgressTextWrapper>
			<S.ProgressBarItemsWrapper>
				<S.ProgressBarItems>
					{CONFIG.components.progressBar.steps.map((item, index, list) => (
						<S.ProgressBarItem key={`pbi-${index}`} activeStep={index <= step - 1} />
					))}
				</S.ProgressBarItems>
			</S.ProgressBarItemsWrapper>
		</>
	);
};

export default Text2StepsProgressBar;
